module.exports = __webpack_public_path__ + "assets/icons/ic_renew_24px.svg";